/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"
import store from "@/store/store";
import Swal from 'sweetalert2'

export default {



  async getAllData({
    commit
  }, item) {


    var res = null;
    try {
      res = await axios.post(store.state.apiURL + "/api/orderheader/chart/monthly-income" , item, store.state.auth.apiHeader);
      commit('SET_DATA', res.data);

    } catch (err) {

      Swal.fire({
        icon: 'error',
        title: 'ไม่สามารถเรียกข้อมูลได้',
      });
      res = null
    }
  },


  async getSellingData({
    commit
  }, item) {


    var res = null;
    try {
      res = await axios.post(store.state.apiURL + "/api/orderheader/chart/monthly-sell-stat" , item, store.state.auth.apiHeader);
      commit('SET_SELLING_DATA', res.data);

    } catch (err) {

      Swal.fire({
        icon: 'error',
        title: 'ไม่สามารถเรียกข้อมูลได้',
      });
      res = null
    }
  },

}
